<div class="undo-block fz-12">
  <span (mousedown)="resetField()" class="fz-12 undo-block__cancel">{{ undoNote }}</span>
  <atl-countdown
    (countdownFinished)="onCountdownFinished()"
    *ngIf="undoTimer"
    [timeRemaining]="undoTimer"
  ></atl-countdown>
</div>
